<template>
	<div class="ohilo-app" :class="isNightMood ? 'night-mood' : ''">
		<!-- <video class="bg-video" :src="require('@/assets/images/video1.mp4')" :loop="true" autoplay muted></video> -->
		<div class="ohilo-app-inner">
			
			<ohilo-header @nightMood="nightMoodHandle" />

			<router-view/>

		</div>
	</div>
</template>

<script>
import OhiloHeader from './components/common/OhiloHeader.vue';

export default {
	components: {
		OhiloHeader
	},
	data() {
		return {
			isNightMood: false
		}
	},
	methods: {
		nightMoodHandle() {
			let mood = localStorage.getItem('isNightMood');
			if (mood == 'true') {
				this.isNightMood = true;
			} else {
				this.isNightMood = false;
			}

		}
	},
	mounted() {
		if (localStorage.getItem('isNightMood') == 'true') {
			this.isNightMood = true;
		} else {
			this.isNightMood = false;
		}
	}
}
</script>
<style>
.ohilo-app.night-mood {
	background: #161616;
}
</style>